
export enum FunctionNameEnum {
    getStores = 'getStores',
    createStore = 'createStore',
    getKiosks = 'getKiosks',
    createKiosk = 'createKiosk',
  
    getStoreById = 'getStoreById',
    updateStore = 'updateStore',
    getGalleryConfig = 'getGalleryConfig',
    setGalleryConfig = 'setGalleryConfig',
    verifyAdminPinCode = 'verifyAdminPinCode',
    setAdminPinCode = 'setAdminPinCode',
    getInvoiceConfig = 'getInvoiceConfig',
    updateInvoiceConfig = 'updateInvoiceConfig',
  
    getTimeInfo = 'getTimeInfo',
    synchronizeBlockStorage = 'synchronizeBlockStorage',
  
    /** Menu */
  
    updateProductCategory = 'updateProductCategory',
    createProductCategory = 'createProductCategory',
    deleteProductCategory = 'deleteProductCategory',
    getProductCategories = 'getProductCategories',
    reorderProductCategories = 'reorderProductCategories',
  
    createProduct = 'createProduct',
    updateProduct = 'updateProduct',
    deleteProduct = 'deleteProduct',
    reorderProducts = 'reorderProducts',
    getProductsByCategoryId = 'getProductsByCategoryId',
    getProducts = 'getProducts',
    soldOutSwitch = 'soldOutSwitch',
  
    createProductAttributeCategory = 'createProductAttributeCategory',
    updateProductAttributeCategory = 'updateProductAttributeCategory',
    deleteProductAttributeCategory = 'deleteProductAttributeCategory',
    reorderProductAttributeCategories = 'reorderProductAttributeCategories',
    getProductAttributeCategories = 'getProductAttributeCategories',
  
    updateProductAttributesInCategory = 'updateProductAttributesInCategory',
    getProductAttributes = 'getProductAttributes',
  
  
    /** invoice */
  
    applyInvoiceNumber = 'applyInvoiceNumber',
    takeInvoiceNumber = 'takeInvoiceNumber',
    checkInvoiceNumber = 'checkInvoiceNumber',
    queryOfficeInfo = 'queryOfficeInfo',
    queryLoveCode = 'queryLoveCode',
  
    /** user */
  
    createStoreAdminUser = 'createStoreAdminUser',
  
    /** order */
    createOrder = 'createOrder',
    attachPayment = 'attachPayment',
    voidOrder = 'voidOrder',
    updateOrder = 'updateOrder',
    getOrders = 'getOrders',
    getRecentOrders = 'getRecentOrders',
    getOrdersByDatetimeRange = 'getOrdersByDatetimeRange',
    getOrdersByInvoiceNumber = 'getOrdersByInvoiceNumber',
    getOrdersByReceiptNumber = 'getOrdersByReceiptNumber',
    closeShift = 'closeShift',
    getCurrentShiftClosing = 'getCurrentShiftClosing',
    getRecentShiftClosings = 'getRecentShiftClosings',
    /** payment */
  
    TSCBIgwAPIPay = 'TSCBIgwAPIPay',
    TSCBIgwAPIRefund = 'TSCBIgwAPIRefund',
    TSCBIgwAPIQuery = 'TSCBIgwAPIQuery',
    TSCBOgwAPIPay = 'TSCBOgwAPIPay',
    TSCBOgwAPIRefund = 'TSCBOgwAPIRefund',
    TSCBOgwAPIQuery = 'TSCBOgwAPIQuery',
  
    /** analysis */
    getDailySummary = 'getDailySummary',
    getAnalysisData = 'getAnalysis',
  
    /** company admin user */
    adminEnableUser = 'adminEnableUser',
    adminDisableUser = 'adminDisableUser',
    adminSetUserPassword = 'adminSetUserPassword',
    listStores = 'listStores',
    listUsersInGroup = 'listUsersInGroup',
  
  }
  
  